import React from 'react';

const LoginScreen = () => {
  return (
    <h1>Login</h1>
  )
}

export default LoginScreen;
